<template>
  <div class="LmChannelList mb-8">
    <lm-label>Select a Channel:</lm-label>
    <ul class="h-56 overflow-y-scroll border" :class="{'has-error': error}">
      <li
        v-for="channel in channels"
        :key="channel._id"
        class="p-4 border-b cursor-pointer hover:bg-gray-200"
        :class="{'bg-gray-200': data === channel.url}"
        @click.prevent="channelSelected(channel)"
      >
        <h1 class="text-gray-900">{{ channel.title }}</h1>
        <p
          v-if="channel.description"
          class="mt-2 mb-0 text-gray-700"
          v-html="channel.description"
        ></p>
      </li>
    </ul>
    <span
      v-if="error"
      class="flex items-center mt-1 pt-1 text-error text-xs border-t border-error"
      >{{ errorMessage }}</span
    >
  </div>
</template>

<script type="text/babel">
import LmLabel from '@/components/ui/LmLabel'
export default {
  name: 'LmChannelList',
  components: {LmLabel},
  props: {
    channels: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      data: null,
      error: false,
      errorMessage: ''
    }
  },
  computed: {},
  methods: {
    channelSelected(channel) {
      this.clearErrors()
      this.data = channel.url
      this.$emit('channelSelected', channel)
    },
    validateData() {
      this.error = false
      if (this.data) return true
      this.error = true
      this.errorMessage = 'Please select a Channel'
      return false
    },
    clearErrors() {
      this.error = false
      this.errorMessage = ''
    },
    reset() {
      this.data = ''
      this.clearErrors()
    },
    // Public
    setData(data) {
      this.data = data
    }
  }
}
</script>
